module.exports = __webpack_public_path__ + "static/media/art49.f9c21ec1.jpg";